import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=1b15a3f4&scoped=true&"
import script from "./Signin.vue?vue&type=script&lang=ts&"
export * from "./Signin.vue?vue&type=script&lang=ts&"
import style0 from "./Signin.vue?vue&type=style&index=0&id=1b15a3f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15a3f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
